import { useContextState } from "../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()
    return {
        container: {
            width: '100%',
            height: '100%',
            paddingTop: '50px',
            paddingRight: '40px',
            paddingBottom: '10px',
            overflowY: 'auto',
            overflowX: 'hidden',
            position: 'relative',
        },
        tabs: {
            width: '100%',
            '& .MuiTabs-flexContainer': {
                columnGap: '10px',
                paddingLeft: '48px',
            },
            '& .MuiTab-root': {
                borderTopLeftRadius: '0px',
                borderTopRightRadius: '0px',
                backgroundColor: 'white',
                bordeR: '1px solid black',
                color: colors.color10,
                '& .MuiTabs-scroller': {
                    overflow: 'auto',
                },
                '&.Mui-selected': {
                    backgroundColor: `${colors.color5}`,
                    color: colors.primary,
                    boxShadow: `0 0 2px ${colors.color10}`,
                    fontWeight: '600',
                },
            },
            '& .MuiTabs-indicator': {
                backgroundColor: 'transparent',
            }, marginTop: 1
        },
        areaTitle: {
            fontSize: '12px',
            color: colors.color10,
            display: 'flex',
            alignItems: 'center'
        },
        viewMore: {
            fontSize: '1rem',
            color: colors.color16,
            '& .MuiSvgIcon-root': {
                fontSize: '1em',
            },
        },
        all: {
            display: 'flex',
            alignItems: 'center',
            '& .remove-m': {
                margin: '0px'
            }
        },
        checkLabel: {
            color: colors.color5,
            fontWeigt: '800',
            fontSize: '12px',
            maxWidth: '120px',
            wordBreak: 'break-word'
        },
        action: {
            width: '100%',
            display: 'flex',
            justifyContent: 'start',
            flexWrap: 'wrap',
            '& .MuiCheckbox-root': {
                margin: 0
            }
        },

    }
}

export { useStyles }
